<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show" >
      
       <h2 class="reg-heading-tab address-heading">Adderss Details</h2>
      <b-col md="6" sm="12" class="reg-tab-container address-wrap">
       

        
        <!-- <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="Nationality"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="text"
            :formatter="format"
            lazy-formatter
            v-model="form.CorrespondenceAddress.Nationality"
            required
            size="sm"
            placeholder="Nationality"
          ></b-form-input>
        </b-form-group> -->
        <b-form-group id="grpAddress" horizontal label-size="sm" label="Address*">
          <b-input-group>
            <b-input-group-prepend>
              <b-form-input
                type="text"
                required
                size="sm"
                placeholder="House No."
                style="width:100px"
                :formatter="format"
                lazy-formatter
                v-model="form.CorrespondenceAddress.HouseNo"
              ></b-form-input>
            </b-input-group-prepend>

            <b-form-input
              type="text"
              placeholder="Building No."
              size="sm"
              :formatter="format"
              lazy-formatter
              v-model="form.CorrespondenceAddress.BuildingNo"
              style="width:50px"
            ></b-form-input>

            <b-input-group-append>
              <b-form-input
                type="text"
                placeholder="Street"
                size="sm"
                style="width:200px"
                :formatter="format"
                lazy-formatter
                v-model="form.CorrespondenceAddress.Street"
              ></b-form-input>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="Area*"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="text"
            :formatter="format"
            lazy-formatter
            v-model="form.CorrespondenceAddress.Locality"
            required
            size="sm"
            placeholder="Area"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="Landmark"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="text"
            :formatter="format"
            lazy-formatter
            v-model="form.CorrespondenceAddress.Landmark"
            size="sm"
            placeholder="Landmark"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="Village/City*"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="text"
            :formatter="format"
            lazy-formatter
            v-model="form.CorrespondenceAddress.Village"
            required
            size="sm"
            placeholder="Village/City"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="Post*"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="text"
            :formatter="format"
            lazy-formatter
            v-model="form.CorrespondenceAddress.Post"
            required
            size="sm"
            placeholder="Post"
          ></b-form-input>
        </b-form-group>
        
        <b-form-group
          id="exampleInputGroup1"
          horizontal
          label="State*"
          label-size="sm"
          label-for="exampleInput1"
        >
          <b-form-select
            id="exampleInput1"
            :options="states"
            value-field="StateID"
            text-field="StateName"
            required
            size="sm"
            @change.native="filterDistricts"
            v-model="form.CorrespondenceAddress.StateID"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="District*"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-select
            id="exampleInput2"
            :options="districts"
            value-field="DistID"
            text-field="DistName"
            required
            size="sm"
            @change.native="filterTalukas"
            v-model="form.CorrespondenceAddress.DistrictID"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup3"
          horizontal
          label="Taluka*"
          label-size="sm"
          label-for="exampleInput3"
        >
          <b-form-select
            id="exampleInput3"
            :options="talukas"
            value-field="TalukaID"
            text-field="TalukaName"
            required
            size="sm"
            v-model="form.CorrespondenceAddress.TalukaID"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          id="exampleInputGroup2"
          horizontal
          label="PinCode*"
          label-size="sm"
          label-for="exampleInput2"
        >
          <b-form-input
            id="exampleInput2"
            type="number"
            v-model="form.CorrespondenceAddress.Pincode"
            required
            size="sm"
            min="100000"
            max="999999"
            placeholder="Pin Code"
          ></b-form-input>
        </b-form-group>
        <!-- <b-form-group id="exampleInputGroup1" horizontal
                            label="Qualification Type <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput1">
                            <b-form-select id="exampleInput1"
                                :options="qualifications"
                                value-field="QualificationTypeID"
                                text-field="QualificationTypeName"
                                required size="sm"  @change.native="onChageQual"
                                v-model="form.UserQualification.QualificationTypeID">
                        </b-form-select>
        </b-form-group>-->
        <!-- <b-form-group
          id="exampleInputGroup3"
          horizontal
          label="Do you have a Pan Card?"
          label-size="sm"
          label-for="radiosg"
        >
          <b-form-radio-group id="radiosp" v-model="form.CorrespondenceAddress.PanCard">
            <b-form-radio value="true">Yes</b-form-radio>
            <b-form-radio value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group> -->
      </b-col>
      <b-row class="mt-2" v-if="!LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  name: "AddressDetails",
  components: { Spinner },
  data() {
    return {
      isAdrsSame: false,
      form: {
        LoginID: "",

        CorrespondenceAddress: {
          StateID: "BB62F7B0-748D-4E64-AD4F-8EF691431FA1",
          DistrictID: "",
          TalukaID: "",
          HouseNo: "",
          BuildingNo: "",
          Street: "",
          Locality: "",
          Landmark: "",
          Village: "",
          Post: "",
          ResidanceSince: "",
          Pincode: "",
          PanCard: true,
          HandiCap: true,
          Nationality: ""
        },
        PermanentAddress: {
        },
        UserEmergencyContact: {
        }
      },
      states: [
      ],
      districts: [],
      talukas: [],
      districtsP: [],
      talukasP: [],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false
    };
  },

  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
     // alert(userinfo);
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    }
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    // copyAddress(checked) {
    //   if (checked) {
    //     this.districtsP = this.districts;
    //     this.talukasP = this.talukas;
    //     this.form.PermanentAddress.StateID = this.form.CorrespondenceAddress.StateID;
    //     this.form.PermanentAddress.DistrictID = this.form.CorrespondenceAddress.DistrictID;
    //     this.form.PermanentAddress.Locality = this.form.CorrespondenceAddress.Locality;
    //     this.form.PermanentAddress.TalukaID = this.form.CorrespondenceAddress.TalukaID;
    //     this.form.PermanentAddress.HouseNo = this.form.CorrespondenceAddress.HouseNo;
    //     this.form.PermanentAddress.BuildingNo = this.form.CorrespondenceAddress.BuildingNo;
    //     this.form.PermanentAddress.Street = this.form.CorrespondenceAddress.Street;
    //     this.form.PermanentAddress.Landmark = this.form.CorrespondenceAddress.Landmark;
    //     this.form.PermanentAddress.Village = this.form.CorrespondenceAddress.Village;
    //     this.form.PermanentAddress.Post = this.form.CorrespondenceAddress.Post;
    //     this.form.PermanentAddress.Pincode = this.form.CorrespondenceAddress.Pincode;
    //   }
    // },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.saveLoanUserAddress(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.$store.dispatch("setLoanDistrict", this.form.CorrespondenceAddress.DistrictID)
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    filterDistricts(evt) {
      let id = evt.target.value;
      this.getDistricts(id);
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          if (response.status == 200) {
            this.districts = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    filterTalukas(evt) {
      let id = evt.target.value;
      let district = _.filter(this.districts, { DistID: id });
      if (district) {
        this.$store.dispatch("setLocation", district[0].DistName);
      }
      this.getTalukas(id);
    },

    getTalukas(districtId) {
      if (this.districts.length > 0) {
        let district = _.filter(this.districts, { DistID: districtId });
        if (district) {
          this.$store.dispatch("setLocation", district[0].DistName);
        }
      }
      let promise = apis.getTaluka(districtId);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.talukas = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    filterDistrictsP(evt) {
      let id = evt.target.value;
      this.getDistrictsP(id);
    },
    getDistrictsP(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.districtsP = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },

    filterTalukasP(evt) {
      let id = evt.target.value;
      this.getTalukasP(id);
    },

    getTalukasP(districtid) {
      let promise = apis.getTaluka(districtid);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.talukasP = response.body;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    let promise = apis.getStates();

    promise
      .then(response => {
        //console.log('Reponse' ,response);
        if (response.status == 200) {
          this.states = response.body;
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message || "Error while populating states";
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    if (this.$store.getters.isLoggedIn) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promiseCA = apis.ReadLoanUseCorrespondanceAddress(userinfo.UserId);
      //let promisePA = apis.ReadUserPermanentAddress(userinfo.UserId);
      //let promiseEC = apis.ReadUserEmgContactDetails(userinfo.UserId);

      promiseCA
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.form.CorrespondenceAddress = response.body;
            this.getDistricts(response.body.StateID);
            this.getTalukas(response.body.DistrictID);
            //console.log('religion',this.religions)
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });

      // promisePA
      //   .then(response => {
      //     //console.log('Reponse' ,response);
      //     if (response.status == 200) {
      //       this.form.PermanentAddress = response.body;
      //       this.getDistrictsP(response.body.StateID);
      //       this.getTalukasP(response.body.DistrictID);
      //       //console.log('religion',this.religions)
      //       this.isLoading = false;
      //       //this.$router.push("/");
      //     } else {
      //       this.alertText = response.body;

      //       this.variant = "warning";
      //       this.showDismissibleAlert = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.alertText = err.message;
      //     this.showDismissibleAlert = true;
      //     this.variant = "danger";
      //   });

      // promiseEC
      //   .then(response => {
      //     //console.log('Reponse' ,response);
      //     if (response.status == 200) {
      //       this.form.UserEmergencyContact = response.body;
      //       //console.log('religion',this.religions)
      //       this.isLoading = false;
      //       //this.$router.push("/");
      //     } else {
      //       this.alertText = response.body;

      //       this.variant = "warning";
      //       this.showDismissibleAlert = true;
      //     }
      //   })
      //   .catch(err => {
      //     this.alertText = err.message;
      //     this.showDismissibleAlert = true;
      //     this.variant = "danger";
      //   });
    }
  }
};
</script>
<style>
.form-group {
  margin-bottom: 0.5rem;
}

.address-wrap{
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
}

.address-heading{
  text-align: center;
}



</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/AddressDetails.vue